import React, { useRef } from 'react';

import ModalAiArtist from './ModalAiArtist';

import AndresBImg from '../../../../../Images/gallery/ai-services/andres-b.png';
import Video1 from '../../../../../Images/gallery/ai-services/andres-b/video-1.png';
import Video2 from '../../../../../Images/gallery/ai-services/andres-b/video-2.png';
import Video3 from '../../../../../Images/gallery/ai-services/andres-b/video-3.png';

import {
  AndresB_Title,
  AndresB_Text,
  AndresB_Video1,
  AndresB_Video2,
  AndresB_Video3,
} from '../../../../../utils/EN/Modals/aiArtists';

const ModalAndresB = () => {
  return (
    <>
      <ModalAiArtist
        id="artist-andres-b"
        artistImage={AndresBImg}
        artistName="Andrés B"
        artistTitle={AndresB_Title}
        artisText={AndresB_Text}
        videoRef1={'andres-video-1'}
        videoBg1={Video1}
        videoText1={AndresB_Video1}
        videoRef2={'andres-video-2'}
        videoBg2={Video2}
        videoText2={AndresB_Video2}
        videoRef3={'andres-video-3'}
        videoBg3={Video3}
        videoText3={AndresB_Video3}
      />
    </>
  );
};

export default ModalAndresB;
